import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { useEffect } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { EjercicioByRange } from "../../ReporteCobranza/Helper/EjercicioByRange";

export const FiltroIndicadorRecuperacion = ({
    children,
    onBoxChange,
    boxstate,
    BoxClick,
    titulo_filtro,
    titulo = "",
    subtitulo = "",
    recarga,
    onExecute
}) => {
    const [openModal, setOpenModal] = useState(false);
    const [state, setState] = useState({
        data: [],
        ejercicio: 0,
        filtrado: "", // Agrega filtrado al estado
    });

    const onOpenModal = () => {
        const container = document.getElementById("mdlFiltros-modal");
        if (!container) return;
        if (openModal) {
            container.style.display = "flex";
            setOpenModal(false);
        } else {
            container.style.display = "none";
            setOpenModal(true);
        }
    };

    const onChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };


    const {
        ejercicioinicio,
        filtrado,
    } = state;

    const handleCargar = () => {
        onExecute(state.ejercicio);
        const container = document.getElementById("mdlFiltros-modal");
        onOpenModal() // Cambia el estado a cargado cuando se presiona el botón
    };

    useEffect(() => {
        if (recarga) {
            const container = document.getElementById("mdlFiltros-modal");
            if (!container) return;
            container.style.display = "none";
            setOpenModal(false);
        }
        const savedState = localStorage.getItem("filtroEstado");
        if (savedState) {
            onOpenModal();
        }
    }, [recarga]);

    return (
        <div className="mdlFiltros-indicador">
            <div className="filtro-indicador-boton" onClick={onOpenModal}>
                <FilterAltIcon /> Filtrar
            </div>
            <div className="mdlFiltros-filtro-indicador-main-container" id="mdlFiltros-modal">
                <PlantillaScreen
                    titulo={`FILTRO DE INDICADOR`}
                    className_main={1}
                    className={"plantilla_buro_credito"}
                >
                    <div className="mdlFiltros-modal-ejercicio">
                        <div className="filtro-group">
                            <label>EJERCICIO</label>
                            <EjercicioByRange
                                name="ejercicio"
                                value={ejercicioinicio}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="mdlFiltros-modal-acciones">
                        <div
                            className="mdlFiltros-modal-acciones-cancelar"
                            onClick={onOpenModal}
                        >
                            Cancelar
                        </div>
                        <div
                            className="mdlFiltros-modal-acciones-guardar"
                            onClick={() => handleCargar()}
                        >
                            Cargar
                        </div>
                    </div>
                </PlantillaScreen>
            </div>
        </div>
    );
};
